import * as yup from "yup";
import { FoilCutterType } from "../../types/foilCutterTypes";

export type FoilCutterFormValues = Partial<FoilCutterType> & {
  foilType: string;
  foilBatch: string;
  foilExpirationDate?: Date | null;
  isFoilSampleStored: boolean;
  other?: boolean;
  otherText?: string;
};

export const foilCutterSchema: yup.ObjectSchema<FoilCutterFormValues> =
  yup.object({
    foilType: yup.string().required("Folientyp ist erforderlich"),
    foilBatch: yup.string().required("Batch-Nummer ist erforderlich"),
    foilExpirationDate: yup
      .date()
      .typeError("Ablaufdatum ist erforderlich")
      .required("Ablaufdatum ist erforderlich"),
    isFoilSampleStored: yup.boolean().required(),
    other: yup.boolean().optional(),
    otherText: yup.string().when("other", {
      is: true,
      then: (schema) =>
        schema.required("Bitte beschreiben Sie 'Andere'").trim(),
      otherwise: (schema) => schema.optional(),
    }),
    dateInProduction: yup.date().nullable().optional(),
    firstname: yup.string().optional(),
    lastname: yup.string().optional(),
    name: yup.string().optional(),
  });
